<template>
    <div class="article-card">
        <!-- <userInfo :item="item" /> -->
        <div class="article-title" @click="toDetail">
            <h3 v-if="item.postName">{{item.postName}}</h3>
        </div>
        <!--postType 资讯类型 0文字动态 1图片动态 2视频动态-->
        <div class="article-desc" @click="toDetail">
            <div class="article-text text" v-if="item.postType==1||item.postType==2">
                {{item.content}}
            </div>
            <div v-else-if="item.content" class="editor-content-view">
                <div class="article-text" :class="{ 'has-table': hasTable }" v-html="displayContent">
                </div>
                <!-- <div class="article-text" v-else v-html="item.content"> -->
            </div>
            <div v-if="item.postType==1&&item.attachList&&item.attachList.length>0">
                <div class="img-wrap">
                    <div v-for="(itemImg,index) in item.attachList" :key="index">
                        <img :src="itemImg.fileUrl" />
                    </div>
                </div>
            </div>
            <div v-if="item.postType==2&&item.attachList&&item.attachList.length>0">
                <div class="video-wrap">
                    <video :poster="item.coverUrl" controls :src="item.picUrl">
                        您的浏览器不支持 video 标签。
                    </video>
                </div>
            </div>
        </div>
        <div class="article-img color-6" @click="toDetail">
			{{item.wantTotalNum}}人已参与
		</div>
        <div class="suggest-content" v-if="item.wantFlag == -1">
            <div class="suggest-text" @click="setSuggestDoWant(1)">想要</div>
            <div class="suggest-no" @click="setSuggestDoWant(0)">不想要</div>
        </div>
        <div class="suggest-content flex-set" v-else @click="toDetail">
            <el-progress :percentage="percentage" :show-text="false" color="#d01c1d" define-back-color="blue" :stroke-width="10" class="suggest-progress"></el-progress>
            <div class="suggest-result">
                <div class="want">{{item.suggestWantNum}}({{percentage}}%)<span v-if="item.wantFlag == 1">想要</span><span v-if="item.wantFlag == 1" class="el-icon-check"></span></div>
                <div class="nowant"><span v-if="item.wantFlag == 0" class="el-icon-check"></span>{{item.suggestNowantNum}}<span v-if="item.wantFlag == 0">({{percentage2}}%)不想要</span></div>
            </div>
        </div>
        <div class="article-card-bottom" @click="toDetail">
            <div class="bottom-l">
                <!-- <div class="article-tags-wrap" v-if="item.talkName">
					<div class="article-tags">
						<span class="tags-icon">#</span>
						<span class="tags-name">{{item.talkName}}</span>
					</div>
				</div> -->
                <div class="article-viewcnt">
                    <span>{{item.addTime | datefmt('yyyy-MM-DD')}}</span>
                    <span>浏览 {{item.viewNum || 0}}</span>
                    <!-- <span> {{item.circleName || 0}}</span> -->
                </div>
            </div>
            <div class="bottom-r" @click="toDetail">
                <div class="article-num">
                    <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                    <span>{{item.discussNum}}</span>
                </div>
                <div class="article-num active" v-if="item.isLike==1" @click.stop="isLikeOrCancel(item)">
                    <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3m7-2V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/></svg>
                    <span>{{item.praiseNum}}</span>
                </div>
                <div class="article-num" v-else @click.stop="isLikeOrCancel(item)">
                    <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3m7-2V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/></svg>
                    <span>{{item.praiseNum}}</span>
                </div>
                <div class="article-num active" v-if="item.isCollect==1" @click.stop="isCollect(item)">
                    <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"/></svg>
                    <span>{{item.collectNum || 0}}</span>
                </div>
                <div class="article-num" v-else @click.stop="isCollect(item)">
                    <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"/></svg>
                    <span>{{item.collectNum || 0}}</span>
                </div>
                <div class="article-num" @click.stop="doShare(item)">
                    <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import posterUrl from '@/assets/user_bg.png'
import userInfo from '@/components/userinfo/userinfo'
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
import '@/assets/css/rich.less'
export default {
    name: 'ArticleCard',
    components: {
        userInfo
    },
    props: {
        item: {
            type: Object,
            value: {}
        },
        type: {
            type: String,
            value: ''
        }
    },
    data() {
        return {
            posterUrl: posterUrl,
            isLike: false,
            likeNum: 14,
            userId: '',
            percentage: '',
            percentage2: ''
        }
    },
    computed: {
        hasTable() {
            const html = String((this.item && this.item.content) || '')
            const match = html.match(/<table[\s>]/i)
            if (!match) return false
            const before = html.substring(0, match.index)
            const text = before.replace(/<[^>]+>/g, '').replace(/&[a-z]+;/gi, ' ').trim()
            return text.length < 105
        },
        displayContent() {
            const html = String((this.item && this.item.content) || '')
            if (!this.hasTable && /<table[\s>]/i.test(html)) {
                return html.replace(/<table[\s\S]*?<\/table>/gi, '')
            }
            return html
        }
    },
    watch: {
        item(){
            if(this.item.wantTotalNum == 0) {
                this.percentage =0
                this.percentage2 =0
            } else {
                this.percentage = Math.floor(Number(this.item.suggestWantNum)/Number(this.item.wantTotalNum) * 100)
                this.percentage2 = Math.floor(Number(this.item.suggestNowantNum)/Number(this.item.wantTotalNum) * 100) 
            }
        }
    },
    created() {
        this.userId = localStorage.getItem('userId') || ''
        if(this.item.wantTotalNum == 0) {
            this.percentage =0
            this.percentage2 =0
        } else {
            this.percentage = Math.floor(Number(this.item.suggestWantNum)/Number(this.item.wantTotalNum) * 100)
            this.percentage2 = Math.floor(Number(this.item.suggestNowantNum)/Number(this.item.wantTotalNum) * 100) 
        }
    },
    methods: {
        toDetail() {
            window.open('/detail?id=' + this.item.id + '&type=' + this.type, '_blank')
        },
        async isLikeOrCancel(item) {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            let param = {
                userId: this.userId,
                postId: item.id,
                flag: item.isLike == 1 ? 0 : 1
            }
            ajaxParam(param)
            const res = await post('v1/circle/likePost', qs.stringify(param))
            if (res.data.code == 200) {
                if (item.isLike == 1) {
                    this.$message.success('取消点赞成功！')
                    item.praiseNum--
                } else {
                    this.$message.success('点赞成功！')
                    item.praiseNum++
                }
                item.isLike = item.isLike == 1 ? 0 : 1

            } else {
                this.$message.error(res.data.msg)
            }
        },
        toCircleIndex(id, categoryId) {
            this.$router.push({
                path: '/circleIndex?id=' + id + '&&categoryId=' + categoryId
            })
        },
        // 想要或者是不想要
        async setSuggestDoWant(state){
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            let param = {
                wantUserId: this.userId,
                postId: this.item.id,
                wantFlag: state
            }
            ajaxParam(param)
            const res = await post('v1/circle/suggestDoWant', qs.stringify(param))
            if (res.data.code == 200) {
                this.$message.success('建议成功！')
                this.$emit('toGetList', {
					item: this.item
				})
            } else {
                this.$message.error(res.data.msg)
            }
	        },
	        async isCollect(item) {
	            if (!this.userId) {
	                this.$router.push({
	                    path: '/login'
	                })
	                return
	            }
	            let param = {
	                userId: this.userId,
	                postId: item.id,
	                flag: item.isCollect == 1 ? 0 : 1
	            }
	            ajaxParam(param)
	            const res = await post('v1/circle/collectPost', qs.stringify(param))
	            if (res.data.code == 200) {
	                if (item.isCollect == 1) {
	                    this.$message.success('取消收藏成功！')
	                    item.collectNum--
	                } else {
	                    this.$message.success('收藏成功！')
	                    item.collectNum++
	                }
	                item.isCollect = item.isCollect == 1 ? 0 : 1
	            } else {
	                this.$message.error(res.data.msg)
	            }
	        },
		        doShare(item) {
		            const url = window.location.origin + '/detail?id=' + item.id + '&type=' + this.type
		            const copyToClipboard = (text) => {
		                if (navigator.clipboard && navigator.clipboard.writeText) {
		                    return navigator.clipboard.writeText(text)
		                }
		                return new Promise((resolve, reject) => {
		                    const textarea = document.createElement('textarea')
		                    textarea.value = text
		                    textarea.style.position = 'fixed'
		                    textarea.style.top = '0'
		                    textarea.style.left = '0'
		                    textarea.style.opacity = '0'
		                    document.body.appendChild(textarea)
		                    textarea.focus()
		                    textarea.select()
		                    try {
		                        const success = document.execCommand('copy')
		                        document.body.removeChild(textarea)
		                        if (success) {
		                            resolve()
		                        } else {
		                            reject(new Error('execCommand copy failed'))
		                        }
		                    } catch (e) {
		                        document.body.removeChild(textarea)
		                        reject(e)
		                    }
		                })
		            }
		            copyToClipboard(url).then(() => {
		                this.$message.success('链接已复制到剪贴板')
		            }).catch(() => {
		                this.$message({ message: '分享链接：' + url, type: 'info', duration: 5000 })
		            })
		        }
	    }
	}
</script>
<style scoped lang="less">
@import '../common.less';

.article-card {
    margin-bottom: 30px;
    border-bottom: 1px solid rgba(50, 50, 51, .14);
    cursor: pointer;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    box-sizing: border-box;

    .article-title {
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 32px;
            height: 18px;
            margin-right: 6px;
            background: rgba(207, 23, 29, .14);
            border-radius: 4px;
            font-size: 12px;
            color: #DD0515;
        }

        h3 {
            font-weight: bold;
            font-size: 16px;
            line-height: 24px;
        }
        .article-icon{
            position: relative;
            width: 24px;
            height: 24px;
            margin-right: 9px;
            img{
                width: 24px;
                height: 24px;
            }

            div{
               position: absolute;
               font-size: 13px;
               color: #fff;
               top: 2px;
               left: 4px;
            }
        }
    }

    .article-desc {
        margin-top: 8px;

        .article-text {
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            word-break: break-word;
            overflow-wrap: anywhere;

            &.has-table {
                display: block;
                -webkit-line-clamp: unset;
                -webkit-box-orient: unset;
                position: relative;
                max-height: 88px;
                overflow: hidden;
                overflow-x: auto;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 20px;
                    background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1));
                    pointer-events: none;
                }
            }

            &.text {
                line-height: 24px;
            }

            :deep img {
                max-width: 100px !important;
                max-height: 100px !important;
                object-fit: cover;
                display: flex;
                flex-wrap: wrap;
                margin-right: 10px;
                margin-top: 10px;
                border-radius: 10px;
            }
        }

        img {
            max-width: 100px !important;
            max-height: 100px !important;
            object-fit: cover;
            display: flex;
            flex-wrap: wrap;
            margin-right: 10px;
            margin-top: 10px;
            border-radius: 10px;
        }

        .img-wrap {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
        }

        .video-wrap {
            display: flex;

            video {
                max-width: 250px;
                max-height: 250px;
                margin-top: 10px;
            }
        }

    }

    .article-img {
        margin-top: 8px;
        color: var(--color-text-opacity);
    }

    .suggest-content{
        width: 100%;
        display: flex;
        margin-top: 20px;
        justify-content: space-between;
        .suggest-text,.suggest-no{
            width:322px;
            height: 38px;
            text-align: center;
            line-height: 38px;
            border: 1px solid #c6bfbf;
            color: #c6bfbf;
            border-radius: 15px;
        }
        .suggest-text{
            border: 1px solid #eb7979;
            color: #eb7979;
        }
        .suggest-progress{
            width: 100%;
            border: none;
        }
    }
    .flex-set{
        flex-direction: column;
        align-items: center;
        .suggest-result{
            width: 100%;
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            .want{
                color: #d01c1d;
            }
            .nowant{    
                color: #6575b4;
            }
        }
    }

    .article-card-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;

        .bottom-l {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: var(--color-text-opacity);

            .article-tags-wrap {
                display: flex;
                cursor: pointer;
            }

            .article-tags {
                display: flex;
                border: 1px solid var(--color-border);
                margin-right: 15px;
                padding: 5px;
                border-radius: 14px;

                .tags-icon {
                    width: 18px;
                    height: 18px;
                    margin-right: 4px;
                    background: #DD0515;
                    border-radius: 14px;
                    color: #fff;
                    line-height: 18px;
                    text-align: center;
                }

                .tags-name {
                    font-size: 12px;
                    color: var(--color-text);
                }
            }

            .article-viewcnt {
                span {
                    padding-right: 15px;
                }

                font-size: 12px;
            }
        }

    }
    .suggest-progress{
        :deep .el-progress-bar__outer{
            background: #6575b4;
        }
    }
    }
</style>